import React from 'react';
import { ViewerControlTooltip } from "../../../controls";
import '@isyc-react/design/main';
import "./view-pdf-progress.style.scss";
export const ViewPdfProgress = props => {
  const {
    loading
  } = props;
  const progress = React.useMemo(() => (loading.loaded / loading.total * 100).toFixed(2), [loading]);
  return /*#__PURE__*/React.createElement(ViewerControlTooltip, {
    tooltip: `${progress}%`
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress view-pdf-progress",
    style: {
      height: '3px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress-bar bg-primary",
    role: "progressbar",
    style: {
      width: `${progress}%`
    }
    // aria-valuenow={progress}
    // aria-valuemin={0}
    // aria-valuemax={100}
  })));
};